import { Link } from 'react-router-dom';
import { H6, Image, LI, UL } from '../../AbstractElements';
import { useAppDispatch, useAppSelector } from '../../ReduxToolkit/Hooks';
import LogoWrapper from './LogoWrapper';
import SimpleBar from 'simplebar-react';
import { Back, Pinned } from '../../utils/Constant';
import { dynamicImage } from '../../Service';
import { ArrowLeft, ArrowRight } from 'react-feather';
import SidebarMenuList from './SidebarMenuList';
import { scrollToLeft, scrollToRight } from '../../ReduxToolkit/Reducers/LayoutSlice';

const Sidebar = () => {
  const dispatch = useAppDispatch();
  const { layout } = useAppSelector((state) => state.themeCustomizer);
  const { toggleSidebar, margin } = useAppSelector((state) => state.layout);
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const role = JSON.parse(localStorage.getItem("user")!).role;
  return (
    <div className={`sidebar-wrapper ${toggleSidebar ? "close_icon" : ""}`} id="sidebarwrappers">
      <LogoWrapper />
      <nav className="sidebar-main">
        <div className={`left-arrow ${margin === 0 ? "disabled" : ""}`} onClick={() => dispatch(scrollToLeft())}>
          <ArrowLeft />
        </div>
        <div
          id="sidebar-menu"
          style={{
            position: "inherit",
            marginLeft: layout === "horizontal-wrapper" ? `${margin}px` : "0px",
            height: "100%", // Ensure full height for scrolling
            overflow: "hidden", // Hide overflow except for SimpleBar
            display: "flex",
            flexDirection: "column"
          }}
        >
          {role === "Admin" ? (
            <UL className="sidebar-links" id="simple-bar" style={{ flex: 1, minHeight: 0 }}>
              <SimpleBar style={{ width: "80px", height: "100%", maxHeight: "calc(100vh - 180px)" }}>
                <LI className="back-btn">
                  <Link to={`/dashboard/default`}>
                    <Image className="img-fluid" src={dynamicImage("logo/logo-icon.png")} alt="logo" />
                  </Link>
                  <div className="mobile-back text-end ">
                    <span>{Back} </span>
                    <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
                  </div>
                </LI>
                <LI className={`pin-title sidebar-main-title ${pinedMenu.length > 1 ? "show" : ""} `}>
                  <div>
                    <H6>{Pinned}</H6>
                  </div>
                </LI>
                <SidebarMenuList />
              </SimpleBar>
            </UL>
          ) : (
            <UL className="sidebar-links" id="simple-bar" style={{ flex: 1, minHeight: '1000px' }}>
              <SimpleBar style={{ width: "80px", height: "100%", maxHeight: "calc(100vh - 180px)" }}>
                <LI className="back-btn">
                  <Link to={`/dashboard/default`}>
                    <Image className="img-fluid" src={dynamicImage("logo/logo-icon.png")} alt="logo" />
                  </Link>
                  <div className="mobile-back text-end ">
                    <span>{Back} </span>
                    <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
                  </div>
                </LI>
                <LI className={`pin-title sidebar-main-title ${pinedMenu.length > 1 ? "show" : ""} `}>
                  <div>
                    <H6>{Pinned}</H6>
                  </div>
                </LI>
                <SidebarMenuList />
              </SimpleBar>
            </UL>
          )}
        </div>
        <div className={`right-arrow ${margin === -3500 ? "disabled" : ""}`} onClick={() => dispatch(scrollToRight())}>
          <ArrowRight />
        </div>
      </nav>
    </div>
  )
}

export default Sidebar;